import { tickerWords } from '@/mocks/home';

export default function Ticker() {
  const items = [...tickerWords, ...tickerWords];

  return (
    <div className="w-full border-y border-background-200 bg-background-100 py-3">
      <div className="relative mx-auto flex w-full max-w-shell items-center gap-6 overflow-hidden px-4 md:px-8">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 font-label text-[11px] font-medium text-background-50">
          <i className="ri-flashlight-fill text-[13px]" />
          实时跟进
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track flex w-max items-center gap-10">
            {items.map((word, index) => (
              <span
                key={`${word}-${index}`}
                className="whitespace-nowrap font-label text-[12.5px] text-foreground-600"
              >
                <i className="ri-price-tag-3-line mr-2 text-accent-600" />
                {word}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}